'use client';

import { UserIcon } from 'lucide-react';
import Link from 'next/link';
import { usePathname, useSearchParams } from 'next/navigation';
import { Tooltipper } from '~/components/common/tooltipper';
import { Button } from '~/components/ui/button';

type SignInButtonProps = {
  brandUrl: string;
};

export function SignInButton({ brandUrl }: SignInButtonProps) {
  const path = usePathname();
  const searchParams = useSearchParams();

  const pathWithParams = `${path}${searchParams.toString() ? `?${searchParams.toString()}` : ''}`;

  const loginUrl = new URL('/login', brandUrl);

  if (
    pathWithParams !== '/' &&
    !pathWithParams.startsWith('/login') &&
    !pathWithParams.startsWith('/password-reset')
  ) {
    loginUrl.searchParams.set('callback', pathWithParams);
  }

  return (
    <Tooltipper content="Sign in">
      <Button
        asChild
        variant="ghost"
        size="icon"
        data-testid="account-icon"
        data-logged-in="false"
      >
        <Link href={loginUrl.href}>
          <span className="sr-only">Sign in</span>
          <UserIcon />
        </Link>
      </Button>
    </Tooltipper>
  );
}
